import React, {Suspense, lazy} from 'react'

import {Route, Routes} from 'react-router'

import LoadingSpinner from "./Util/LoadingSpinner";
import RequireAuth from "../Auth/RequireAuth";

const PaddedLoadingSpinner = (
    <div style={{padding: '100px 0 0 0'}}>
        <LoadingSpinner size={30}/>
    </div>);

const Accelo = lazy(() => import(/* webpackChunkName: "accelo" */ './Accelo/AcceloRoutes'));

const AdminPanel = lazy(() => import(/* webpackChunkName: "admin" */ './Admin/AdminPanel' ));

const AttachmentsReport = lazy(() => import(/* webpackChunkName: "attachmentsReport" */ './Attachments/AttachmentsReport'));

const BufferToolReport = lazy(() => import(/* webpackChunkName: "bufferToolReport" */ './Reports/BufferToolReport' ));

const CommentsReport = lazy(() => import(/* webpackChunkName: "commentsReport" */ './Comments/CommentsReport'));

const ConfigurationRoutes = lazy(() => import(/* webpackChunkName: "configuration" */ './Configuration/ConfigurationRoutes'));

const ContactsRoutes = lazy(() => import(/* webpackChunkName: "contacts" */ './Contacts/ContactsRoutes'));

const Dashboard = lazy(() => import(/* webpackChunkName: "dashboard" */ './Dashboard/Dashboard'));

const DrillersRoutes = lazy(() => import(/* webpackChunkName: "drillers" */ './Drillers/DrillersRoutes'));

const DrillingCompaniesRoutes = lazy(() => import(/* webpackChunkName: "drilling_companies" */ './DrillingCompanies/DrillingCompaniesRoutes'))

const EntitiesRoutes = lazy(() => import(/* webpackChunkName: "entities" */ './Entities/EntitiesRoutes'));

const Experimental = lazy(() => import(/* webpackChunkName: "experimental" */ './Experimental/Experimental'));

const Forms = lazy(() => import(/* webpackChunkName: "forms" */ './Forms/Forms'));

const GamByGps = lazy(() => import(/* webpackChunkName: "gam" */ './GAM/GamByGps'))

const WellGeology = lazy(() => import(/* webpackChunkName: "geology" */ './Geology/WellGeology'));

const InspectionsRoutes = lazy(() => import(/* webpackChunkName: "inspections" */ './Inspections/InspectionsRoutes'));

const MobileMapsRoutes = lazy(() => import(/* webpackChunkName: "mobileMaps" */ './MobileMaps/MobileMapsRoutes'));

const MonitoringWellsChart = lazy(() => import(/* webpackChunkName: "monitoringWellChart" */ './WaterLevels/MonitoringWellsChart'));

const MapsRoutes = lazy(() => import(/* webpackChunkName: "maps" */ './Maps/MapsRoutes'));

const MonitoringWellReport = lazy(() => import(/* webpackChunkName: "monitoringWellReport" */ './Reports/MonitoringWellReport'));

const OwnersRoutes = lazy(() => import(/* webpackChunkName: "owners" */ './Owners/OwnersRoutes'))

const PermitsRoutes = lazy(() => import(/* webpackChunkName: "permits" */ './Permits/PermitsRoutes'));

const PermittingRoutes = lazy(() => import(/* webpackChunkName: "permitting" */ './Permitting/PermittingRoutes'));

const Portal = lazy(() => import(/* webpackChunkName: "permits" */ './Portal/Portal'));

const ProductionList = lazy(() => import(/* webpackChunkName: "production" */ './Production/ProductionList'));

const ProductionByCountyAndAquifer = lazy(() => import(/* webpackChunkName: "productionByCountyAndAquifer" */ './Reports/ProductionByCountyAndAquifer'));

const ProductionByWellUse = lazy(() => import(/* webpackChunkName: "productionByWellUse" */ './Reports/ProductionByWellUse'));

const PubRoutes = lazy(() => import(/* webpackChunkName: "pub" */ './Pub/PubRoutes'));

const PumpInstallationsRoutes = lazy(() => import(/* webpackChunkName: "pumpInstallations" */ './PumpInstallation/PumpInstallationRoutes'));

const PWS = lazy(() => import(/* webpackChunkName: "pws" */ './PWS/PWSRoutes'));

const RainfallRoutes = lazy(() => import(/* webpackChunkName: "rainfall" */ './Rainfall/RainfallRoutes'));

const StateDataReport = lazy(() => import(/* webpackChunkName: "stateDataReport" */ './StateDataReport/StateDataReport'));

const StateDrillerLicensesReport = lazy(() => import(/* webpackChunkName: "stateDrillerLicensesReport" */ './Reports/StateDrillerLicensesReport'));

const SystemsRoutes = lazy(() => import(/* webpackChunkName: "systems" */ './Systems/SystemsRoutes'));

const TagsList = lazy(() => import(/* webpackChunkName: "tags" */ './Contacts/TagsList'));

const TaskApprovalReportTabs = lazy(() => import(/* webpackChunkName: "taskApprovalReportTabs" */ './Reports/TaskApprovalReportTabs'));

const TCEQPWSReport = lazy(() => import(/* webpackChunkName: "tceqPwsReport" */ './Reports/TCEQPWSReport'));

const TermsTabs = lazy(() => import(/* webpackChunkName: "taskApprovalReportTabs" */ './Terms/TermsTabs'));

const UserRoutes = lazy(() => import(/* webpackChunkName: "user" */ './Users/UserRoutes'));

const UserSettings = lazy(() => import(/* webpackChunkName: "settings" */ './Settings/UserSettings'));

const VideosRoutes = lazy(() => import(/* webpackChunkName: "videos" */ './Videos/VideosRoutes'));

const WaterLevelsByRegion = lazy(() => import(/* webpackChunkName: "waterLevelsByRegion" */ './WaterLevels/WaterLevelsByRegion'));

const WaterLevelsRoutes = lazy(() => import(/* webpackChunkName: "waterlevels" */ './WaterLevels/WaterLevelRoutes'));

const WaterQualityRoutes = lazy(() => import(/* webpackChunkName: "waterquality" */ './WaterQuality/WaterQualityRoutes'));

const WellReport = lazy(() => import(/* webpackChunkName: "wells" */ './Reports/WellReport'));

const WellSearch = lazy(() => import(/* webpackChunkName: "wells" */ './Search/WellSearch'))

const WellsRoutes = lazy(() => import(/* webpackChunkName: "wells" */ './Wells/WellsRoutes'));

const Main = () => {
    return (
        <Suspense fallback={PaddedLoadingSpinner}>
            <Routes>
                <Route path={'/accelo/*'}
                       element={<RequireAuth allowedPermissions={['accelo:read', 'accelo:write']}>
                           <Accelo/>
                       </RequireAuth>}/>
                <Route path={'/admin'}
                       element={<RequireAuth requireSuperuser={true} requiredPermissions={['admin_panel:write']}>
                           <AdminPanel/>
                       </RequireAuth>}/>
                <Route path={'/attachments'}
                       element={<RequireAuth
                           allowedPermissions={['attachments_report:read', 'attachments_report:write']}>
                           <AttachmentsReport/>
                       </RequireAuth>}/>
                <Route path={'/comments'}
                       element={<RequireAuth allowedPermissions={['comments_report:read', 'comments_report:write']}>
                           <CommentsReport/>
                       </RequireAuth>}/>
                <Route path={'/configuration/*'}
                       element={<RequireAuth allowedPermissions={['configuration:read', 'configuration:write']}>
                           <ConfigurationRoutes/>
                       </RequireAuth>}/>
                <Route path={'/contacts/*'} element={<ContactsRoutes/>}/>
                <Route path={'/dashboard'} element={<Dashboard/>}/>
                <Route path={'/drillers/*'} element={<DrillersRoutes/>}/>
                <Route path={'/drilling_companies/*'} element={<DrillingCompaniesRoutes/>}/>
                <Route path={'/entities/*'} element={<EntitiesRoutes/>}/>
                <Route path={'/experimental'}
                       element={<RequireAuth>
                           <Experimental/>
                       </RequireAuth>}/>
                <Route path={'/forms/*'} element={<Forms/>}/>
                <Route path={'/gambygps'} element={<GamByGps/>}/>
                <Route path={'/inspections/*'} element={<InspectionsRoutes/>}/>
                <Route path={'/maps/*'} element={<MapsRoutes/>}/>
                <Route path={'/mobile/*'} element={<MobileMapsRoutes/>}/>
                <Route path={"/monitoringWellsChart"} element={<RequireAuth requiredPermissions={['water_level:read']}>
                    <MonitoringWellsChart/>
                </RequireAuth>}/>
                <Route path={'/owners/*'} element={<OwnersRoutes/>}/>
                <Route path="/permits/*" element={<PermitsRoutes/>}/>
                <Route path={'/permitting/*'} element={<PermittingRoutes/>}/>
                <Route path={'/portal'}
                       element={<RequireAuth requireSuperuser={false}>
                           <Portal/>
                       </RequireAuth>}/>
                <Route path={'/production'}
                       element={<RequireAuth requiredPermissions={['production:read']}>
                           <ProductionList/>
                       </RequireAuth>}/>
                <Route path={'/pump_installations/*'}
                       element={<PumpInstallationsRoutes/>}/>
                <Route path={'/rainfall/*'} element={<RainfallRoutes/>}/>
                <Route path="/reports/bufferTool"
                       element={<RequireAuth requiredPermissions={['buffer_tool:read']}>
                           <BufferToolReport/>
                       </RequireAuth>}/>
                <Route path={'/reports/tceq_pws'}
                       element={<RequireAuth requiredPermissions={['well_report:read']}>
                           <TCEQPWSReport/>
                       </RequireAuth>}/>
                <Route path="/reports/sdr"
                       element={<RequireAuth requiredPermissions={['well_report:read']}>
                           <StateDataReport/>
                       </RequireAuth>}/>
                <Route path="/reports/productionByCountyAndAquifer"
                       element={<RequireAuth requiredPermissions={['production:read']}>
                           <ProductionByCountyAndAquifer/>
                       </RequireAuth>}/>
                <Route path="/reports/productionByCountyAndAquiferV1"
                       element={<RequireAuth requiredPermissions={['production:read']}>
                           <ProductionByCountyAndAquifer version={1}/>
                       </RequireAuth>}/>
                <Route path="/reports/productionByWellUse"
                       element={<RequireAuth requiredPermissions={['production:read']}>
                           <ProductionByWellUse/>
                       </RequireAuth>}/>
                <Route path={'/reports/stateDrillerLicenses'} element={<StateDrillerLicensesReport/>}/>
                <Route path={'/reports/taskApproval'}
                       element={<RequireAuth requiredPermissions={['task_approval_report:read']}>
                           <TaskApprovalReportTabs/>
                       </RequireAuth>}/>
                <Route path={'/terms'}
                       element={<RequireAuth requireSuperuser={false}>
                           <TermsTabs/>
                       </RequireAuth>}/>
                <Route path={'/reports/wells'}
                       element={<RequireAuth requiredPermissions={['well_report:read']}>
                           <WellReport/>
                       </RequireAuth>}/>
                <Route path={'/reports/monitoringWell'}
                       element={<RequireAuth allowedPermissions={['water_level:read', 'water_level:write']}>
                           <MonitoringWellReport/>
                       </RequireAuth>}/>
                <Route path={'/reports/geology/well'}
                       element={<RequireAuth allowedPermissions={['stratigraphy:read', 'stratigraphy:write']}>
                           <WellGeology/>
                       </RequireAuth>}/>
                <Route path="/search"
                       element={<RequireAuth
                           allowedPermissions={['well_application:create', 'well_application:read', 'well_application:write']}
                           requiredPermissions={['search:read']}>
                           <WellSearch/>
                       </RequireAuth>}/>
                <Route path={"/settings"} element={<RequireAuth><UserSettings/></RequireAuth>}/>
                <Route path="/systems/*" element={<SystemsRoutes/>}/>
                <Route path={"/tags"} element={<RequireAuth requireSuperuser={true}
                                                            allowedPermissions={['contact_tags:read', 'contact_tags:write']}>
                    <TagsList/>
                </RequireAuth>}/>
                <Route path="/users/*" element={<UserRoutes/>}/>
                <Route path={"/videos/*"} element={<VideosRoutes/>}/>
                <Route path={"/waterlevels/*"} element={<WaterLevelsRoutes/>}/>
                <Route path={"/waterlevelsByRegion"} element={<RequireAuth requiredPermissions={['water_level:read']}>
                    <WaterLevelsByRegion/>
                </RequireAuth>}/>
                <Route path={"/waterquality/*"} element={<WaterQualityRoutes/>}/>
                <Route path="/wells/*" element={<WellsRoutes/>}/>
                <Route path="/pub/*" element={<PubRoutes/>}/>
                <Route path={"/pws/*"} element={<PWS/>}/>
                <Route path={"/loader"} element={<LoadingSpinner/>}/>
            </Routes>
        </Suspense>
    )
}

export default Main;